"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const branding_1 = require("src/context/branding");
const theme_mode_1 = require("src/hooks/theme_mode");
const b = b_1.default.with('rating');
;
// eslint-disable-next-line complexity
function useRatingBranding() {
    const isDark = (0, theme_mode_1.useIsDarkMode)();
    const branding = (0, branding_1.useBrandingContext)() || {};
    const { colors: { main = '#fc0' } = {}, rating: { borderWidth, colors: { borderActive = 'transparent', borderInactive = '#B9B9B9', fillActive = main, fillInactive = 'white' } = {} } = {}, darkTheme: { colors: { main: mainDark = main } = {}, rating: { borderWidth: borderWidthDark, colors: { borderActive: borderActiveDark = borderActive, borderInactive: borderInactiveDark = borderInactive, fillActive: fillActiveDark = mainDark, fillInactive: fillInactiveDark = 'transparent' } = {} } = {} } = {} } = branding;
    return {
        borderWidth: isDark ? borderWidthDark || borderWidth : borderWidth,
        borderActive: isDark ? borderActiveDark : borderActive,
        borderInactive: isDark ? borderInactive : borderInactiveDark,
        fillActive: isDark ? fillActiveDark : fillActive,
        fillInactive: isDark ? fillInactiveDark : fillInactive,
    };
}
// eslint-disable-next-line complexity
function QuestionRatingStar(props) {
    const { active, handleClickOption, option, questionId, starConfig } = props;
    const { borderWidth = undefined, borderActive, borderInactive, fillActive, fillInactive } = useRatingBranding();
    const { borderWidth: configBorderWidth = 2, width, height, path, fillRule = 'nonzero', clipRule = 'nonzero', fillOpacity } = starConfig;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper'), tabIndex: 0, style: {
            width: `${width}px`,
            height: `${width}px`
        } }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ className: b('option', { active }), "data-value": option.id }, { children: [(0, jsx_runtime_1.jsx)("svg", Object.assign({ width: `${width}px`, height: `${height}px`, viewBox: `0 0 ${width} ${height}`, fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: fillRule, clipRule: clipRule, d: path, stroke: active ? borderActive : borderInactive, strokeWidth: borderWidth === undefined ? configBorderWidth : borderWidth, fill: active ? fillActive : fillInactive, fillOpacity: fillOpacity }) })), (0, jsx_runtime_1.jsx)("input", { type: 'radio', checked: option.checked, "data-index": questionId, value: option.id, onClick: handleClickOption, className: b('input') })] })) }), option.id));
}
exports.default = QuestionRatingStar;
